import loadable from 'utils/loadable';

export const OfferLetterTemplateEditor = loadable(() => import('./index'), {
  fallback: null,
});
